export const dataTablePageSizeOptions = [5, 10, 15, 25, 50, 100];
export const dataTableSlotProps = {
    toolbar: {
        showQuickFilter: true,
        quickFilterProps: { debounceMs: 500 },
    },
};
export const getDataTableSerialNumber = (obj) => String(obj.row.index);
